<!-- Overlay para descarga de app -->
<div
  *ngIf="showOverlay"
  class="overlay-banner"
  [ngClass]="{ 'fade-in': showOverlay, 'fade-out': !showOverlay }"
>
  <div class="overlay-content">
    <button class="btn-close" (click)="closeOverlay()">
      <span class="material-icons">close</span>
    </button>
    <h2>Atención afiliado</h2>
    <p>
      Descargue nuestra aplicación móvil para acceder a sus servicios de
      manera rápida y sencilla. Para ingresar, utilice su usuario y clave
      previamente activados.
    </p>
    <div>
      <button class="btn-primary-chip" (click)="redirectToApp()">
        Descargar
      </button>
    </div>
  </div>
</div>

<!-- Banner informativo (solo festivo) -->
<div class="info-banner-wrapper" *ngIf="showBanner">
  <mat-card class="info-card">
    <mat-card-content>
      <div class="info-banner">
        <h3 class="banner-title">
          <span class="material-icons">celebration</span>
          Información importante
          <span class="material-icons">celebration</span>
        </h3>
        <p class="banner-message">
          Por razones operativas relacionadas con las fiestas, las
          autorizaciones que se soliciten a partir de las 13hs del
          27/12/2024 se tratarán a partir del 02/01/2025.
        </p>
        <button class="btn-primary-chip" (click)="hideBanner()">
          Aceptar
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- Accesos rápidos -->
<div class="rapidos-container">
  <div class="features-grid">
    <!-- 1. Mi Credencial -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">badge</span>
      </div>
      <h3>Mi Credencial</h3>
      <p>El uso de esta credencial es personal e intransferible.</p>
      <a routerLink="/mi-credencial" class="link-btn">Ver</a>
    </div>

    <!-- 2. Orden Médica -->
    <div class="feature-item skeleton-card" *ngIf="cargandoRosario">
      <div class="icon">
        <span class="micro-spinner"></span>
      </div>
      <div class="skeleton-line skeleton-title"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line short"></div>
    </div>

    <div class="feature-item" *ngIf="!cargandoRosario && showRosarioGuardia" (click)="openOrdenMedica()">
      <div class="icon">
        <span class="material-icons">medical_services</span>
      </div>
      <h3>Rosario Guardia</h3>
      <p>Genere su orden para atención.</p>
      <a class="link-btn">Ver</a>
    </div>

    <!-- 3. Turnos -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">calendar_month</span>
      </div>
      <h3>Turnos</h3>
      <p>Consultorios internos</p>
      <a href="https://signomedico.org/turnos_online" target="_blank" class="link-btn">Ver</a>
    </div>

    <!-- 4. Nuevo trámite -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">send</span>
      </div>
      <h3>Nuevo trámite</h3>
      <p>Complete sus solicitudes de autorización y otros procedimientos administrativos.</p>
      <a routerLink="/tramites-disponibles" class="link-btn">Ver</a>
    </div>

    <!-- 5. Trámites pendientes -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">description</span>
      </div>
      <h3>Trámites pendientes</h3>
      <p>Controle y realice sus solicitudes.</p>
      <a routerLink="/usuario-solicitudes" class="link-btn">Ver</a>
    </div>

    <!-- 6. Cartilla Médica -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">search</span>
      </div>
      <h3>Cartilla Médica</h3>
      <p>Cartilla Médica, búsquedas.</p>
      <a routerLink="/cartilla-buscador" class="link-btn">Ver</a>
    </div>

    <!-- 7. Mis Familiares -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">groups</span>
      </div>
      <h3>Mis Familiares</h3>
      <p>Familiares a cargo</p>
      <a routerLink="/familiares" class="link-btn">Ver</a>
    </div>

    <!-- 8. COSEGUROS (nueva tarjeta) -->
    <div class="feature-item">
      <div class="icon">
        <span class="material-icons">medical_services</span>
      </div>
      <h3>COSEGUROS</h3>
      <p>Informacion sobre coseguros y cartilla medica.</p>
      <a routerLink="/coseguros" class="link-btn">Ver</a>
    </div>
  </div>
</div>